(() => {
  "use strict";

  const R = '[data-bsell-grid="true"]';
  const C = ".desk-prod-card";

  const root = () => document.querySelector(R);
  const n2 = (n) => String(n).padStart(2, "0");

  function badges() {
    const r = root();
    if (!r) return;

    r.querySelectorAll(C).forEach((card) => {
      const b = card.querySelector(".desk-badge-sale");
      if (!b) return;

      const p = parseFloat(card.getAttribute("data-price") || "0");
      const c = parseFloat(card.getAttribute("data-compare") || "0");

      if (p > 0 && c > 0 && c > p) {
        const pct = Math.round((1 - p / c) * 100);
        b.textContent = "-" + pct + "%";
      } else {
        b.textContent = "Sale";
      }
    });
  }

  function countdown() {
    const r = root();
    if (!r) return;

    const hEl = r.querySelector("[data-bsell-hours]");
    const mEl = r.querySelector("[data-bsell-minutes]");
    const sEl = r.querySelector("[data-bsell-seconds]");
    if (!hEl || !mEl || !sEl) return;

    const fmt = new Intl.DateTimeFormat("en-US", {
      timeZone: "Europe/Berlin",
      hour12: false,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });

    const parts = () => {
      const out = {};
      fmt.formatToParts(new Date()).forEach((p) => {
        if (p.type !== "literal") out[p.type] = p.value;
      });
      return out;
    };

    const nowUTC = () => {
      const t = parts();
      return Date.UTC(+t.year, +t.month - 1, +t.day, +t.hour, +t.minute, +t.second);
    };

    const nextMidUTC = () => {
      const t = parts();
      return Date.UTC(+t.year, +t.month - 1, +t.day + 1, 0, 0, 0);
    };

    const tick = () => {
      let d = nextMidUTC() - nowUTC();
      if (d < 0) d = 0;

      const hh = Math.floor(d / 36e5);
      d -= hh * 36e5;
      const mm = Math.floor(d / 6e4);
      d -= mm * 6e4;
      const ss = Math.floor(d / 1e3);

      hEl.textContent = n2(hh);
      mEl.textContent = n2(mm);
      sEl.textContent = n2(ss);
    };

    tick();

    if (countdown.__iv) clearInterval(countdown.__iv);
    countdown.__iv = setInterval(tick, 1000);

    addEventListener("pageshow", tick);
    addEventListener("visibilitychange", () => { if (!document.hidden) tick(); }, { passive: true });
  }

  function boot() {
    badges();
    countdown();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", boot);
  document.addEventListener("shopify:section:select", boot);
})();
